/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './Heading.style';

type Props = {
  children: React.Node,
  level?: number,
  layoutClass?: string,
};

const useStyles = createUseStyles(styles);

const Heading = ({
  children,
  level: propLevel,
  layoutClass,
}: Props): React.Node => {
  const defaultLevel = 1;

  let level = propLevel ? parseInt(propLevel, 10) : defaultLevel;

  if (level < 1 || level > 6) {
    level = defaultLevel;
  }

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, layoutClass);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |---------------------------------------------------------------------------
   */

  return React.createElement(`h${level}`, { className: rootClasses }, children);
};

export default compose(React.memo)(Heading);
